/**
 * The Burton Bikes manufacturing and finish story.
 * Source of truth: docs/BRAND-CONTEXT.md — update both together.
 */

export interface CraftPillar {
  id: string
  index: string
  label: string
  title: string
  body: string
}

export const CRAFT_PILLARS: CraftPillar[] = [
  {
    id: 'additive',
    index: '01',
    label: 'Process',
    title: 'Additive manufacturing',
    body: 'Complex frame structures are grown, not tooled. Additive manufacturing lets us build the parts around the bike we actually want to make — not the bike that is easiest to manufacture. No production tooling. No compromise on geometry.',
  },
  {
    id: 'filament-wound',
    index: '02',
    label: 'Structure',
    title: 'Filament-wound carbon',
    body: 'Every carbon tube is an engineered structure, never off-the-shelf stock. Fibre direction, wall thickness, and tube shape are selected for the job each tube has to do — stiffness where you need precision, compliance where you need feel.',
  },
  {
    id: 'forged-carbon',
    index: '03',
    label: 'Componentry',
    title: 'Optimised forged carbon',
    body: 'Where the shape of a part demands it, optimised forged carbon creates strong, compact, complex components matched to the load paths of the frame. An engineering tool, never a cosmetic effect.',
  },
  {
    id: 'hardware',
    index: '04',
    label: 'Detail',
    title: 'Aerospace hardware',
    body: 'Even the small parts matter. Bolts, axles, and fittings in aircraft-grade aluminium keep every detail light and precise — with titanium available for riders who want to take the build further still.',
  },
]

export const FINISH_PHILOSOPHY = {
  eyebrow: 'The Finish',
  heading: 'The finish is the signature.',
  body: 'Your machine does not have to look like anyone else’s. Begin with Burton’s house finish direction, or push it somewhere entirely personal — raw carbon, gloss or satin black, metallic gold detailing, exposed metal, custom decals, titanium hardware. This is not colour picking. It is commissioning the final look of a custom machine.',
  note: 'Paint, decals, exposed carbon, raw metal, metallic details, and hardware choices are all discussed as part of the commission.',
}
